import CustomerLayout from '@/views/layout/customer';
import HelpdeskDocumentationsListPage from '@/views/pages/documentations/list';
import HelpdeskDocumentationsManagePage from '@/views/pages/documentations/manage';
import HelpdeskFileManagerListPage from '@/views/pages/file-manager/list';
import HelpdeskFileManagerManagePage from '@/views/pages/file-manager/manage';
import HelpdeskFinanceListPage from '@/views/pages/finance/list';
import HelpdeskPositionsListPage from '@/views/pages/positions/list';
import HelpdeskPositionsManagePage from '@/views/pages/positions/manage';
import HelpdeskTimelineListPage from '@/views/pages/timeline/list';
import HelpdeskTicketsEditPage from '@/views/pages/tickets/edit';
import HelpdeskTicketsListPage from '@/views/pages/tickets/list';
import HelpdeskTicketsManagePage from '@/views/pages/tickets/manage';
import HelpdeskTicketsNewPage from '@/views/pages/tickets/new';
import WorkspaceHomePage from '@/views/pages/workspace/home';
import WorkspaceBoardsPage from '@/views/pages/workspace/boards';
import WorkspaceInsightsIndexPage from '@/views/pages/workspace/insights';
import WorkspaceProjectsListPage from '@/views/pages/workspace/projects/list';
import WorkspaceRelationshipsPage from '@/views/pages/workspace/relationships';
import WorkspaceRelationshipCompaniesPage from '@/views/pages/workspace/relationships/companies';
import WorkspaceServerMonitoringListPage from '@/views/pages/workspace/server-monitoring/list';
import WorkspaceServerMonitoringManagePage from '@/views/pages/workspace/server-monitoring/manage';
import WorkspaceSystemExtensionsPage from '@/views/pages/workspace/system-extensions';
import WorkspaceVaultListPage from '@/views/pages/workspace/vault/list';
import WorkspaceVaultManagePage from '@/views/pages/workspace/vault/manage';
import WorkspaceVaultNewPage from '@/views/pages/workspace/vault/new';
import WorkspaceVaultRenamePage from '@/views/pages/workspace/vault/rename';
import {WORKSPACE_CAPABILITIES} from '@/utils/access-capabilities';
import {customerRouteMeta} from '@/views/routes/route-meta';

export const customerRoutes = [
    {
        path: '/system-extensions',
        component: CustomerLayout,
        children: [
            {path: '', component: WorkspaceSystemExtensionsPage, meta: customerRouteMeta()},
        ],
    },
    {
        path: '/dashboard',
        component: CustomerLayout,
        children: [
            {path: '', component: WorkspaceHomePage, meta: customerRouteMeta()},
        ],
    },
    {
        path: '/tickets',
        component: CustomerLayout,
        redirect: '/tickets/list',
        children: [
            {path: 'list', component: HelpdeskTicketsListPage, meta: customerRouteMeta()},
            {path: 'new', component: HelpdeskTicketsNewPage, meta: customerRouteMeta()},
            {path: ':id/edit', component: HelpdeskTicketsEditPage, meta: customerRouteMeta()},
            {path: ':id', component: HelpdeskTicketsManagePage, meta: customerRouteMeta()},
        ],
    },
    {
        path: '/documentations',
        component: CustomerLayout,
        redirect: '/documentations/list',
        children: [
            {path: 'list', component: HelpdeskDocumentationsListPage, meta: customerRouteMeta()},
            {path: ':id', component: HelpdeskDocumentationsManagePage, meta: customerRouteMeta()},
        ],
    },
    {
        path: '/positions',
        component: CustomerLayout,
        redirect: '/positions/list',
        children: [
            {path: 'list', component: HelpdeskPositionsListPage, meta: customerRouteMeta()},
            {path: 'timeline', redirect: '/timeline'},
            {path: ':id', component: HelpdeskPositionsManagePage, meta: customerRouteMeta()},
        ],
    },
    {
        path: '/timeline',
        component: CustomerLayout,
        children: [
            {path: '', component: HelpdeskTimelineListPage, meta: customerRouteMeta()},
            {path: 'new', redirect: '/timeline'},
            {path: ':id/manage', redirect: '/timeline'},
        ],
    },
    {
        path: '/projects',
        component: CustomerLayout,
        redirect: '/projects/list',
        children: [
            {path: 'list', component: WorkspaceProjectsListPage, meta: customerRouteMeta()},
        ],
    },
    {
        path: '/relationships',
        component: CustomerLayout,
        children: [
            {path: '', component: WorkspaceRelationshipsPage, meta: customerRouteMeta({requiredCapability: WORKSPACE_CAPABILITIES.RELATIONSHIPS})},
            {path: 'companies', component: WorkspaceRelationshipCompaniesPage, meta: customerRouteMeta({requiredCapability: WORKSPACE_CAPABILITIES.RELATIONSHIPS})},
        ],
    },
    {
        path: '/boards',
        component: CustomerLayout,
        children: [
            {path: '', component: WorkspaceBoardsPage, meta: customerRouteMeta()},
        ],
    },
    {
        path: '/file-manager',
        component: CustomerLayout,
        redirect: '/file-manager/list',
        children: [
            {path: 'list', component: HelpdeskFileManagerListPage, meta: customerRouteMeta()},
            {path: ':id', component: HelpdeskFileManagerManagePage, meta: customerRouteMeta()},
        ],
    },
    {
        path: '/finance',
        component: CustomerLayout,
        redirect: '/finance/list',
        children: [
            {path: 'list', component: HelpdeskFinanceListPage, meta: customerRouteMeta()},
        ],
    },
    {
        path: '/vault',
        component: CustomerLayout,
        redirect: '/vault/list',
        children: [
            {path: 'list', component: WorkspaceVaultListPage, meta: customerRouteMeta()},
            {path: 'new', component: WorkspaceVaultNewPage, meta: customerRouteMeta()},
            {path: ':id/manage', component: WorkspaceVaultManagePage, meta: customerRouteMeta()},
            {path: ':id/rename', component: WorkspaceVaultRenamePage, meta: customerRouteMeta()},
        ],
    },
    {
        path: '/insights',
        component: CustomerLayout,
        redirect: '/insights/server-monitoring',
        children: [
            {path: '', component: WorkspaceInsightsIndexPage, meta: customerRouteMeta()},
            {path: 'server-monitoring', component: WorkspaceServerMonitoringListPage, meta: customerRouteMeta()},
            {path: 'server-monitoring/:siteId/manage', component: WorkspaceServerMonitoringManagePage, meta: customerRouteMeta()},
        ],
    },
];
